import { ParsedUrlQuery } from 'querystring'
import { FilterByKeys } from '../context'

export const checkSessionFilter = (
  recruitType: 'intern' | 'recruit',
  query: ParsedUrlQuery,
) => {
  if (typeof window !== 'undefined') {
    const savedQuery = sessionStorage.getItem(`${recruitType}Filter`)
    return savedQuery ? JSON.parse(savedQuery) : query
  }
  return query
}

export const parseFilterByParams = (
  query: ParsedUrlQuery,
  filterKeys: Array<FilterByKeys>,
): { [key: string]: string[] | string } => {
  const filterByParams: { [key: string]: string[] | string } = {}

  filterKeys.forEach((key) => {
    const queryKey = `filterBy_${key}`

    if (query[queryKey]) {
      const value = query[queryKey] ?? ''

      filterByParams[key] = normalizeFilterValue(key, value)
    } else {
      filterByParams[key] = key === 'q' ? '' : []
    }
  })

  return filterByParams
}

const normalizeFilterValue = (
  key: FilterByKeys,
  value: string | string[],
): string | string[] => {
  if (key === 'q') {
    // 검색어는 항상 문자열
    return Array.isArray(value) ? value[0] || '' : value
  }
  // 다른 필터들은 배열
  return Array.isArray(value) ? value : [value]
}
